import { useSelector } from 'react-redux';

import { getRejectedPagination } from '../../selectors';

const usePagination = () => useSelector(getRejectedPagination);

export default usePagination;
